import {
  type ApiProcessRecurlyInvoiceForProfileInfoReq,
  type PurchaseRes,
  v1ProfileInfoClaimPersonCreate,
  v1ProfileInfoNDetail,
  v1ProfileInfoNProcessAccessUpdate,
} from '@on3/api/src';
import { type IUser } from '@on3/ui-lib/api/schema/custom-contracts';
import { externalApi } from '@on3/ui-lib/index';
import { settleSequentially } from '@on3/ui-lib/utils/api';
import { getUserIpAddress } from '@public/utils/tracking';
import { trackFbPurchase } from '@public/utils/tracking/facebook';
import { trackGooglePurchase } from '@public/utils/tracking/google';
import { type Checkout } from '@public/utils/tracking/types';

interface PurchaseTrackingProps extends Checkout {
  userKey: string | number;
  userEmail?: string | null;
}

const postPurchase = {
  default: async (user: IUser, purchase: Checkout) => {
    await Promise.allSettled([
      trackPurchase({
        userKey: user.uid,
        userEmail: user.e,
        ...purchase,
      }),
    ]);
  },
  recruits: async (purchase: PurchaseRes, data: Record<string, any>) => {
    const accessInfo: ApiProcessRecurlyInvoiceForProfileInfoReq = {
      $type: 'recurlyInvoice',
      invoiceNumber: purchase.invoiceNumber as string,
    };

    if (data.athlete?.key) {
      const { athlete } = data;

      await v1ProfileInfoClaimPersonCreate(externalApi, {
        accessInfo,
        personKey: athlete.key,
      });
    } else if (data.key && data.nonce) {
      const { key, nonce } = data;

      await settleSequentially(
        [
          () => v1ProfileInfoNDetail(externalApi, key, nonce),
          () =>
            v1ProfileInfoNProcessAccessUpdate(externalApi, key, nonce, {
              accessInfo,
            }),
        ],
        true,
      );
    }
  },
};

const trackPurchase = async ({
  userKey,
  userEmail = null,
  ...conversion
}: PurchaseTrackingProps) => {
  const userIp = await getUserIpAddress();

  await Promise.allSettled([
    trackGooglePurchase(userKey, userEmail ?? '', userIp, conversion),
    trackFbPurchase(userKey, userEmail ?? '', userIp, conversion),
  ]);
};

export { postPurchase, trackPurchase };
